export default {
  name: 'background',
  type: 'layout',
  active: false,
  data: {
    image: '',
    color: ''
  }
}
